export const RouteGetMerchflows_merchflowId_S1_s1UserTriggerId_Templates_templateId_logs =
  "/merchflows/:merchflowId/s1/:s1UserTriggerId/templates/:templateId/logs";

export interface ResponseGetMerchflows_merchflowId_S1_s1UserTriggerId_Templates_templateId_logs {
  s1_algo_request: unknown | null;
  s1_algo_response: unknown | null;
}
